// extracted by mini-css-extract-plugin
export var categoryContainer = "cH_kr";
export var categoryLabel = "cH_kt";
export var categoryList = "cH_kv";
export var otherCategoryLabel = "cH_ks";